import { render, staticRenderFns } from "./BnCmdFour.vue?vue&type=template&id=ceed8fa6&"
import script from "./BnCmdFour.vue?vue&type=script&lang=js&"
export * from "./BnCmdFour.vue?vue&type=script&lang=js&"
import style0 from "./BnCmdFour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports